import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: Revit .PAT files not recognized',
  slug: 'qa-revit-pat-files-not-recognized',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/revit-pat-files-not-recognized/m-p/9602263#M288128" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5556838" target="_blank" rel="noreferrer">@KevDeegan</a> on 6/25/2020 on the Revit Architecture Forum:</strong><br/>
        When trying to load a .pat file, I get the following error.<br/>
        <img src="/img/forum_content/KevDeegan_1-1593103115848.png"/>
        <br/><br/>
        When I check the filepath, the .pat files icon is different. I am thinking this is why it is not loading.<br/>
        <img src="/img/forum_content/KevDeegan_0-1593103053158.png"/>
        <br/><br/>
        The icon should look like these<br/>
        <img src="/img/forum_content/KevDeegan_2-1593103176298.png"/>
        <br/><br/>
        Any idea why this is happening?
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 6/25/2020:</strong><br/>
        In addition to potentially not being a PAT file or the right type in general, that is also the error output when there is also something internally wrong with the PAT file. (lines too dense, spacing or offset non-compliance etc - it wont even load the PAT file into the program). Which as @ToanDN has pointed out, the icon doesn't matter. It looks like its correctly saved as a .pat file.
        <br/><br/>
        If you upload or copy in the text here for that PAT file i can investigate for you. Or head over to Pattycake and paste in the values in our text editor, it will pop out a red '!' for which lines may be issues.
        <br/><br/>
        Cheers<br/>
        <img src="/img/forum_content/Pattycake_Kyle_0-1593105526333.png"/>
        <small className="translucent">Error on line 14</small>
      </blockquote> 

      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5556838" target="_blank" rel="noreferrer">@KevDeegan</a> on 6/25/2020:</strong><br/>
        This is great. Thank you for pointing it out. 
      </blockquote>

      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5556838" target="_blank" rel="noreferrer">@KevDeegan</a> on 6/25/2020:</strong><br/>
        Still getting the error after using Pattycake to create the .pat file.
        <br/>
        <img src="/img/forum_content/KevDeegan_0-1593111856430.png"/>
        <br/>
        <br/>
        Copied it into a .txt and renamed to .pat<br/>
        When creating and new Model pattern, I navigate to this .pat and I still get the error<br/>
        <img src="/img/forum_content/KevDeegan_1-1593111905282.png"/>
      </blockquote>

      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 6/25/2020:</strong><br/>
        See the error on line 8?
        <br/><br/>
        The "<span className="text-danger">!</span>" tells you something is wrong there. If you hover over that icon, it will tell you more specifically about the error.
        <br/><br/>
        In this case i can tell you its that your offset is set to zero (0). The offset tells it how to repeat the line, and if that is zero, there is no 'repeating'. So for DRAFTING patterns (for example), Autodesk wants an offset of .002" or more.
        <br/><br/>
        This goes into the offset and values for what they do.<br/>
        <a href="https://knowledge.autodesk.com/support/autocad-lt/learn-explore/caas/CloudHelp/cloudhelp/2018/ENU/AutoCAD-LT/files/GUID-79B99823-7600-4CAB-BD12-04D5103D90CB-htm.html" target="_blank" rel="noreferrer">https://knowledge.autodesk.com/support/autocad-lt/learn-explore/caas/CloudHelp/cloudhelp/2018/ENU/Au...</a>
        <br/><br/>
        Once you clear all line errors, you should be able to load it in.
      </blockquote> 


      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5556838" target="_blank" rel="noreferrer">@KevDeegan</a> on 6/25/2020:</strong><br/>
        Thank you @Pattycake_Kyle<br/>
        Pattycake has made a serious difference in understanding pattern files
      </blockquote>

      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 6/25/2020:</strong><br/>
        So glad to hear 😎
        <br/><br/>
        Reach out anytime hi@pattycake.io if you are having troubles. And keep an eye out, we're prepping to release some great doc resources for help in creating pattern files and understand them more.
        <br/><br/>
        Cheers! 🎂🎂🎂🎂🎂🎂🎂
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-revit-pat-files-not-recognized.js